/**
 * @flow
 * @relayHash 717d7069c4b53b95a5bcb7e80362f5ac
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AddTraveler_AddTraveler_MutationVariables = {|
  input: {
    tripId?: ?string;
    travelerId?: ?string;
    firstName?: ?string;
    lastName?: ?string;
    email?: ?string;
    birthdate?: ?string;
    isAdult?: ?boolean;
    isPrimaryTraveler?: ?boolean;
    primaryTravelerId?: ?string;
    primaryTravelerName?: ?string;
    relationship?: ?string;
    insideCircle?: ?boolean;
    needsTraining?: ?boolean;
    needsVetting?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type AddTraveler_AddTraveler_MutationResponse = {|
  +addTraveler: ?{|
    +trip: ?{|
      +numTravelers: ?number;
      +tripName: ?string;
      +primaryTravelerName: ?string;
      +travelers: ?$ReadOnlyArray<?{|
        +id: string;
        +firstName: string;
        +lastName: string;
        +isPrimaryTraveler: boolean;
        +primaryTravelerName: string;
        +primaryTraveler: ?{|
          +id: string;
        |};
        +birthdate: ?any;
        +adult: boolean;
      |}>;
    |};
  |};
|};
*/


/*
mutation AddTraveler_AddTraveler_Mutation(
  $input: AddTravelerInput!
) {
  addTraveler(input: $input) {
    trip {
      numTravelers
      tripName
      primaryTravelerName
      travelers {
        id
        firstName
        lastName
        isPrimaryTraveler
        primaryTravelerName
        primaryTraveler {
          id
        }
        birthdate
        adult
      }
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "AddTravelerInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddTraveler_AddTraveler_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "AddTravelerInput!"
          }
        ],
        "concreteType": "AddTravelerPayload",
        "name": "addTraveler",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "numTravelers",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tripName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "primaryTravelerName",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Traveler",
                "name": "travelers",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isPrimaryTraveler",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "primaryTravelerName",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Traveler",
                    "name": "primaryTraveler",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "birthdate",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "adult",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AddTraveler_AddTraveler_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "AddTravelerInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "AddTraveler_AddTraveler_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "AddTravelerInput!"
          }
        ],
        "concreteType": "AddTravelerPayload",
        "name": "addTraveler",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "numTravelers",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tripName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "primaryTravelerName",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Traveler",
                "name": "travelers",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isPrimaryTraveler",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "primaryTravelerName",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Traveler",
                    "name": "primaryTraveler",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "birthdate",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "adult",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation AddTraveler_AddTraveler_Mutation(\n  $input: AddTravelerInput!\n) {\n  addTraveler(input: $input) {\n    trip {\n      numTravelers\n      tripName\n      primaryTravelerName\n      travelers {\n        id\n        firstName\n        lastName\n        isPrimaryTraveler\n        primaryTravelerName\n        primaryTraveler {\n          id\n        }\n        birthdate\n        adult\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Trips/__generated__/AddTraveler_AddTraveler_Mutation.graphql.js